import React from 'react';

const PdfIcon = ({ size = 28 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="#1888ff"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ flexShrink: 0, display: 'block' }}
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <text
      x="5"
      y="19"
      fontSize="5.5"
      fontWeight="bold"
      fill="#1888ff"
      stroke="none"
      fontFamily="sans-serif"
    >
      PDF
    </text>
  </svg>
);

export default PdfIcon;
